import React, { FC, useState, Dispatch, SetStateAction } from "react";
import { observer } from "mobx-react-lite";
import { makeStyles, Box, TextField } from "@material-ui/core";
import { Text } from "../components/Text";
import colors from "../constants/colors";
import Button from "../components/Button";
import { store } from "../store";
import { useIdentityContext } from "react-netlify-identity";

interface IForgotPassword {
  setForgotPassword: Dispatch<SetStateAction<boolean>>;
}

export const ForgotPassword: FC<IForgotPassword> = observer(
  ({ setForgotPassword }) => {
    const { isEmailValid, errors, setErrors, inputEmail } = store;
    const [submitted, setSubmitted] = useState<boolean>(false);
    const { requestPasswordRecovery } = useIdentityContext();
    const classes = styles();

    const handleReset = async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      if (!isEmailValid) {
        setErrors(["Please enter a valid email address"]);
      } else {
        try {
          const request = await requestPasswordRecovery(inputEmail);
          setSubmitted(true);
          console.log("req", request);
        } catch (err) {
          console.log(err);
        }
      }
      return false;
    };

    if (!submitted)
      return (
        <Box className={classes.container}>
          <form onSubmit={handleReset} className={classes.innerContainer}>
            <Box>
              <Text gutterBottom bold align="center">
                Forgot your password?
              </Text>
              <Text align="center">
                Enter your email address below and we’ll send you instructions
                to reset your password.
              </Text>
            </Box>
            <Box className={classes.inputContainer}>
              <TextField
                InputProps={{ classes: { input: classes.input } }}
                placeholder="EMAIL"
                className={classes.input}
                type="email"
                value={inputEmail}
                error={!!errors.find((err) => err.includes("email"))}
                name="inputEmail"
                variant="filled"
                onChange={(e) =>
                  (store[e.currentTarget.name] = e.currentTarget.value)
                }
              />
            </Box>
            <Box className={classes.errors}>
              {errors.map((error) => (
                <Text size="small" color="error" key={error}>
                  {error}
                </Text>
              ))}
            </Box>
            <Button type="submit">SUBMIT</Button>
            <Box
              className={classes.contextualLink}
              onClick={() => setForgotPassword(false)}
            >
              Nevermind, go back
            </Box>
          </form>
        </Box>
      );

    return (
      <Box className={classes.container}>
        <Text bold align="center">
          Thanks!
        </Text>
        <Text align="center">
          We've sent a link to your email to reset your account.
        </Text>
      </Box>
    );
  }
);

const styles = makeStyles((theme) => ({
  container: {
    backgroundColor: colors.grey,
    [theme.breakpoints.up("md")]: {
      borderRadius: 0,
      boxShadow: "0 50vh 0 50vh #F2F2F2",
      padding: 50,
      width: "100%",
    },
  },
  innerContainer: {
    [theme.breakpoints.up("md")]: {
      maxWidth: 600,
      margin: "0 auto",
    },
  },
  input: {
    width: "100%",
    background: "white",
  },
  inputContainer: {
    margin: "20px 0px",
  },
  errors: {
    marginBottom: 20,
  },
  contextualLink: {
    textAlign: "center",
    marginTop: 20,
    cursor: "pointer",
  },
}));
